import React from 'react'
import { required } from './validators'
import FormattedMessage from '../components/FormattedMessage/FormattedMessage'
import {
  TextInput,
  TextareaInput,
  SelectInput,
  DateInput,
  CheckInput,
  FileuploadInput,
  RadioInput,
} from '../components/Input'

export const renderField = ({
  input,
  label,
  type,
  containerclass,
  options,
  inputType,
  password,
  placeholder,
  prepend,
  dark,
  disabled,
  selected,
  inputRef,
  isPop,
  validate, // Add this to detect required fields
  autocomplete: explicitAutocomplete,
  meta: { touched, error, warning, dirty },
}) => {
  const isRequired =
    Array.isArray(validate) &&
    validate.some(
      validator =>
        validator &&
        (validator.name === 'required' || validator === required || validator === 'required')
    )

  const fieldId = `field-${input.name}`
  const errorId = (touched || dirty) && error ? `${fieldId}-error` : undefined

  let autocomplete = explicitAutocomplete
  if (!autocomplete) {
    if (type === 'password') {
      autocomplete = 'current-password'
    } else if (type === 'email') {
      autocomplete = 'email'
    }
  }

  const accessibilityProps = {
    id: fieldId,
    required: isRequired,
    'aria-required': isRequired,
    'aria-invalid': !!(touched && error),
    'aria-describedby': errorId,
    ...(autocomplete && { autocomplete }),
  }

  return (
    <div className={(containerclass || '') + ((touched || dirty) && error ? ' input-error' : '')}>
      {inputType === 'input' && (
        <TextInput
          {...input}
          inputRef={inputRef}
          dark={!!dark}
          password={!!password}
          label={label}
          type={type}
          prepend={prepend}
          {...accessibilityProps}
        />
      )}
      {inputType === 'textarea' && (
        <TextareaInput
          {...input}
          label={label}
          type={type}
          className="form-control"
          {...accessibilityProps}
        />
      )}
      {inputType === 'select' && (
        <SelectInput
          {...input}
          placeholder={placeholder}
          label={label}
          type={type}
          options={options}
          {...accessibilityProps}
        />
      )}
      {inputType === 'date' && (
        <DateInput
          {...input}
          label={label}
          disabled={disabled}
          isPop={isPop}
          {...accessibilityProps}
        />
      )}
      {inputType === 'checkbox' && <CheckInput {...input} label={label} {...accessibilityProps} />}
      {inputType === 'fileupload' && <FileuploadInput {...input} {...accessibilityProps} />}
      {inputType === 'radio' && (
        <RadioInput
          {...input}
          selected={selected}
          label={label}
          onChange={input.onChange}
          {...accessibilityProps}
        />
      )}

      {(touched || dirty) &&
        inputType !== 'checkbox' &&
        ((error && error instanceof Object && error.string && (
          <span className="form-field-validation-error-message" id={errorId} aria-live="polite">
            <FormattedMessage id={error.string} values={error.values} />
          </span>
        )) ||
          (error && !(error instanceof Object) && error && (
            <span className="form-field-validation-error-message" id={errorId} aria-live="polite">
              <FormattedMessage id={error} />
            </span>
          )) ||
          (warning && typeof warning === 'string' && (
            <span aria-live="polite">
              <FormattedMessage id={warning} />
            </span>
          )))}
    </div>
  )
}
